import { __rest, __assign } from '../../node_modules/tslib/tslib.es6.js';
import React__default__default from 'react';
import PropTypes__default from 'prop-types';
import styles from '../../node_modules/@flixbus/honeycomb/dist/scss/components/main-wrapper.scss.js';
import HoneyBem from '../../packages/honey-bem/honey-bem.js';
import { Injecss } from '../../packages/injecss/injecss.js';

var bem = HoneyBem.init('main-wrapper', styles);
var MainWrapper = function (_a) {
  var children = _a.children,
    extraClasses = _a.extraClasses,
    full = _a.full,
    rest = __rest(_a, ["children", "extraClasses", "full"]);
  return /*#__PURE__*/React__default__default.createElement("div", __assign({
    className: bem.b({
      full: full
    }, extraClasses)
  }, rest), children);
};
MainWrapper.displayName = 'MainWrapper';
MainWrapper.defaultProps = {
  extraClasses: '',
  full: false
};
MainWrapper.propTypes = {
  children: PropTypes__default.node.isRequired,
  extraClasses: PropTypes__default.string,
  full: PropTypes__default.bool
};
var mainWrapper = Injecss(MainWrapper, styles);

export { MainWrapper, mainWrapper as default };
